import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface ShareCollectionPropertyItem {
  propertyId: string
  taCommissionRate: number
  multiUnitGrpId: string | null
  isMultiUnit: boolean
}

export interface ShareFavouriteListPayload {
  favouriteListId: string | number
  clientName: string
  clientEmail: string
  emailSubject: string
  personalMessage?: string
  sendCopyToAgent?: boolean
  checkIn: string
  checkOut: string
  guestCount: number
  petCount?: number
  properties: ShareCollectionPropertyItem[]
}

export interface ShareFavouriteListRequest extends Partial<AxiosRequestConfig> {
  data: ShareFavouriteListPayload
}

export interface FavouriteListCopyResponse {
  agentCopySent: boolean
  emailSent: boolean
  favouriteListId: number
  propertyCount: number
}

export interface ShareFavouriteListResponseData extends ResponseData {
  data: FavouriteListCopyResponse
}

export interface ShareFavouriteListResponse extends AxiosResponse {
  data: ShareFavouriteListResponseData
}

export function shareFavouriteListApi(
  { data }: ShareFavouriteListRequest,
  axiosInstance: AxiosInstance,
): Promise<ShareFavouriteListResponse> {
  return axiosInstance({
    data,
    method: "post",
    url: "/share-link/share-favourite-list",
  }) as Promise<ShareFavouriteListResponse>
}
